import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";
import {
  faFileAlt,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Documentor = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="scroll">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 lg:col-span-3 xxl:col-span-3">
              <div className="sticky">
                <aside className="main-sidebar sidebar ">
                  <section className="sidebar p-t-b-40">
                    <ul className="sidebar-menu scroll">
                      <li>
                        <AnchorLink to="/get-started" title="User Guides">
                          <i className="doc_guide_icon">
                            <FontAwesomeIcon icon={faFileAlt} />
                          </i>
                          User Guides
                        </AnchorLink>
                      </li>
                      <li>
                        <AnchorLink
                          to="/configuration"
                          title="Configuration Guide"
                        >
                          <i className="doc_guide_icon">
                            <FontAwesomeIcon icon={faFileAlt} />
                          </i>
                          Configuration Guide
                        </AnchorLink>

                        <ul>
                          <li>
                            <AnchorLink
                              to="/configuration#register"
                              title="Register"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/configuration#interface"
                              title="Create Interface"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/configuration#account-access"
                              title="Account Access"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/configuration#payment-initation"
                              title="Payment Initiation"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/configuration#integration"
                              title="Integration Settings"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/configuration#security"
                              title="Security"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/configuration#testing"
                              title="Testing"
                            />
                          </li>
                        </ul>
                      </li>
                      <li>
                        <AnchorLink to="/integration" title="Authorisation">
                          <i className="doc_guide_icon">
                            <FontAwesomeIcon icon={faFileAlt} />
                          </i>
                          Integration Guide
                        </AnchorLink>
                        <ul>
                          <li>
                            <AnchorLink
                              to="/integration#authorisation"
                              title="Authorisation"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/integration#consent"
                              title="Consent Management"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/integration#resources"
                              title="Resources"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/integration#schema"
                              title="Resource Schema"
                            />
                          </li>
                          <li>
                            <AnchorLink
                              to="/integration#testing"
                              title="Testing"
                            />
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </section>
                </aside>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-8 xxl:col-span-9">
              <div className="DocBodySection">
                <h2 id="config">
                  <a className="anchor" href="#config">
                    Configuration Guide
                  </a>
                </h2>
                <hr />
                <p>
                  For an overview of the Management Console including how to
                  create and manage your own Dedicated Interface, see our
                  Configuration Guide.
                </p>
                <Link to="/configuration/">
                  <button className="cca-btn " id="login_button" type="button">
                    <div>
                      Configuration Guide<span></span>
                      <i className="sbmt_but_icon">
                        <FontAwesomeIcon icon={faArrowCircleRight} />
                      </i>
                    </div>

                    <span></span>
                  </button>
                </Link>
                

                <h2 id="implementation">
                  <a className="anchor" href="#implementation">
                    Integration Guide
                  </a>
                </h2>
                <hr />
                <p>
                  For instructions on how to integrate your application with
                  tell.connect, and to view details and customisation options,
                  see our Implementation Guide.
                </p>
                <Link to="/integration/">
                  <button className="cca-btn " id="login_button" type="button">
                    <div>
                    Integration Guide<span></span>
                      <i className="sbmt_but_icon">
                        <FontAwesomeIcon icon={faArrowCircleRight} />
                      </i>
                    </div>

                    <span></span>
                  </button>
                </Link>
                

                <h2 id="support">
                  <a className="anchor" href="#support">
                    Support
                  </a>
                </h2>
                <hr />
                <p>
                  If you have any questions or require any support, feel free to
                  email us and we'll get back to you as soon as possible.
                </p>
                <a className="side-menu" href="mailto:info@tell.money">
                  <button className="cca-btn " id="login_button" type="button">
                    <div>
                      Support<span></span>
                      <i className="sbmt_but_icon">
                        <FontAwesomeIcon icon={faArrowCircleRight} />
                      </i>
                    </div>

                    <span></span>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentor;
